<script>
import moment from 'moment';

export default {
  name: 'LikeActionItem',
  components: {
    capitalizeWords: require('../../mixins/utils.js').default,
  },
  props: {
    data: { type: Object },
  },
  computed: {
    createdAt() {
      return moment(this.data.created_at).format('L');
    },
    profileLink() {
      return `/profile/${this.data.slug}`;
    }
  },
};
</script>
<template>
  <a :href="profileLink" class="like-item-container footnote neutral4-color">
    <p>
        <span class="primary-color">{{ capitalizeWords(data.name) }}</span>&nbsp;
        <span>Liked This on</span>&nbsp;
        <span>{{ createdAt }}</span></p>
    </a>
</template>
<style scoped>
.like-item-container {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--neutral2);
    width: max-content;
}
.like-item-container:only-child,
.like-item-container:last-child {
    border-bottom: none;
}
.like-item-container p {
    margin: 4px 0;
}
</style>
